import React, { useState } from "react";
import Iterator from "../utils/Iterator";
import Visibility from "../utils/Visibility";
import { useTranslation } from "react-i18next";
import SubOptionModel from "../../Models/SubOptionModel";
import OptionModel from "../../Models/OptionModel";
import UAEDirhamIcon from "../utils/UAEDirhamIcon";

function OptionsProduct({
  options,
  name,
  price,
  setOptionsSelected,
  optionsSelected,
}: {
  options: OptionModel[];
  name: string;
  price: number;
  setOptionsSelected: any;
  optionsSelected: any;
}) {
  const { t } = useTranslation();

  const [totals, setTotals] = useState<number[]>([]);
  const total = totals.reduce((a, b) => a + b, 0);
  const onChangePrice = (
    price: number,
    subOption: SubOptionModel,
    i: number,
    e: OptionModel
  ) => {
    setTotals((prev) => {
      const clone = [...prev];
      clone[i] = price;
      return clone;
    });
    setOptionsSelected((prev: any) => {
      if (subOption) {
        const clone = [...prev];
        if (clone.find((o) => o.option.id === e.id))
          clone.splice(
            clone.findIndex((o) => o.option.id === e.id),
            1
          );
        clone.push({ subOption: subOption, option: e });
        return clone;
      } else {
        const clone = [...prev];
        const filteredClone = clone.filter((o) => {
          return o.option.id !== e.id;
        });
        return filteredClone;
      }
    });
  };
  return (
    <div className="flex flex-col gap-3 text-onBackground">
      <h6 className="font-bold">{t("gloabl.options")} </h6>
      <div className="flex flex-col gap-2">
        <Iterator
          data={options}
          render={(e, i) => (
            <OptionsList
              option={e}
              key={e.id}
              name={name as keyof OptionModel}
              onPriceChange={(price: number, subOption: SubOptionModel) => {
                onChangePrice(price, subOption, i, e);
              }}
            />
          )}
        />
      </div>
      <div className="border-b-2 border-onBackground"></div>
      <p className="flex gap-1 justify-end text-[15px] ">
        <span className="font-bold">{t("gloabl.totalPrice")}:</span>{" "}
        <span className="font-semibold flex items-center gap-1">
          <UAEDirhamIcon className="w-4 h-4" />
          {total + price}
        </span>
      </p>
    </div>
  );
}
const OptionsList = ({
  option,
  name,
  onPriceChange,
}: {
  option: any;
  name: keyof OptionModel;
  onPriceChange: any;
}) => {
  const [selectedOption, setSelectedOption] = useState<SubOptionModel | null>(
    null
  );
  const clickHandle = (subOption: SubOptionModel) => {
    if (selectedOption != undefined) {
      if (selectedOption.id === subOption.id) {
        onPriceChange(0, null);
        setSelectedOption(null);
      } else {
        onPriceChange(subOption.price, subOption);
        setSelectedOption(subOption);
      }
    } else {
      onPriceChange(subOption.price, subOption);
      setSelectedOption(subOption);
    }
  };

  return (
    <div className="px-1 flex flex-col">
      <p className="text-base font-bold">{option[name]} </p>
      <Visibility visible={option.subOption && option.subOption.length > 0}>
        <div className="px-2 flex flex-col gap-1 ">
          <Iterator
            data={option.subOption}
            render={(e: SubOptionModel, i) => (
              <SubOptionsList
                key={i}
                subOption={e}
                name={name}
                option={option}
                checked={selectedOption?.id === e.id}
                onClick={clickHandle}
              />
            )}
          />
        </div>
      </Visibility>
    </div>
  );
};

const SubOptionsList = ({
  subOption,
  option,
  name,
  onClick,
  checked,
}: {
  subOption: SubOptionModel;
  option: OptionModel;
  name: string;
  onClick: (subOption: SubOptionModel) => void;
  checked?: boolean;
}) => {
  return (
    <div
      className="cursor-pointer flex items-center gap-3"
      onClick={() => onClick(subOption)}
    >
      <input
        className={`accent-primary  appearance-none w-4 h-4 border-2 border-onBackground rounded-full ${
          checked ? "bg-primary" : ""
        }`}
        type="radio"
        name={`option_${option.id}`}
        value={subOption.id}
        checked={checked}
      />
      <div className="w-full flex justify-between">
        <p className="">{subOption[name as keyof SubOptionModel]}</p>
        <Visibility visible={subOption.price > 0}>
          <p className="w-1/6 flex gap-1 items-center" dir="ltr">
            <UAEDirhamIcon className="w-4 h-4" />
            <span className=""> {subOption.price}</span>
          </p>
        </Visibility>
      </div>
    </div>
  );
};
export default OptionsProduct;
